import {
  Scope,
  BrowserClient,
  defaultStackParser,
  getDefaultIntegrations,
  makeFetchTransport,
} from '@sentry/browser'

const dsn =
  'https://bba66a91745efd5672fb5f9dc7d362a4@o37417.ingest.us.sentry.io/4509643823382528'

export const createSentry = ({
  release,
  transport = makeFetchTransport,
}: {
  release: string
  transport?: typeof makeFetchTransport
}): Scope => {
  const scope = new Scope()
  const client = new BrowserClient({
    normalizeDepth: 8,
    transport,
    stackParser: defaultStackParser,
    integrations: getDefaultIntegrations({}),
    dsn,
    release,
    beforeSend: event => {
      const userAgentHeader =
        event.request?.headers?.['User-Agent'] ??
        event.request?.headers?.['user-agent']
      // See: https://github.com/wix-private/security/blob/master/krampus/docs/krampus-victims.md#first-was-it-krampus
      if (
        typeof userAgentHeader === 'string' &&
        userAgentHeader.endsWith('-AdamIsTheChaosMonkey')
      ) {
        return null
      }
      return event
    },
  })
  scope.setClient(client)
  client.init()
  scope.addBreadcrumb({ category: 'appLoadStarted' })
  return scope
}
